export default {
    // 越南语
    LOCALE_HTML: {
        'msg.language': 'vi',
        'msg.title': 'Tiêu đề ',
        'msg.type': 'Phân loại vấn đề ',
        'msg.des': 'Mô tả vấn đề ',
        'msg.phone': 'Số điện thoại ',
        'msg.regionCode': 'Mã vùng',
        'msg.email': 'E-mail ',
        'msg.choose': 'Vui lòng chọn một loại',
        'msg.detail': 'Lời dặn dò chi tiết ',
        'msg.back': 'Trở về ',
        'your.msg': 'Vui lòng để lại lời nhắn ',
        'msg.record': 'Bản ghi tin nhắn ',
        'msg.success': 'Để lại lời nhắn thành công',
        'to.record': 'Đi tới bản ghi tin nhắn ',
        completed: 'Hoàn thành ',
        submit: 'Gửi đi ',
        'success.desc': 'Tin nhắn của bạn đã được gửi thành công, cảm ơn bạn',
        'msg.form.input': 'Vui lòng nhập',
        'msg.reply': 'Trả lời ',
        'comment.suc': 'Cảm ơn đánh giá của bạn',
        'comment.fail': 'Gửi không thành công ',
        'comment.placeholder':
            'Hoan nghênh đưa ra ý kiến cho các dịch vụ của chúng tôi ',
        'reply.suc': 'Gửi thành công ',
        'reply.fail': 'Vui lòng nhập câu trả lời của bạn',
        'reply.placeholder': 'Vui lòng nhập câu trả lời của bạn',
        'msg.more': 'Xem thêm',
        'msg.collapse': 'Cất đi',
        'msg.myservice': 'Đánh giá dịch vụ của tôi',
        'msg.evaluate': 'Đánh giá dịch vụ ',
        'msg.evaluateTitle': 'Đánh giá dịch vụ ',
        'msg.score': 'Ghi bàn ',
        'msg.remark': 'Bình luận',
        'msg.status.created': 'Đã tạo ',
        'msg.status.pending': 'Đang chờ xử lý ',
        'msg.status.processing': 'xử lý',
        'msg.status.solved': 'giải quyết',
        'msg.service.reply': 'Dịch vụ khách hàng trả lời',
        'msg.my.reply': 'câu trả lời của bạn',
        'msg.toast.des': 'Mô tả vấn đề trống',
        'msg.toast.type': 'Phân loại vấn đề là trống ',
        'msg.toast.title': 'Tiêu đề là trống',
        'msg.toast.none': 'Không được để trống',
        'msg.toast.noAnnex': 'Vui lòng tải lên tệp đính kèm',
        'msg.toast.noEmail': 'E-mail không được để trống',
        'msg.toast.noTel': 'Vui lòng nhập email chính xác của bạn ',
        'msg.toast.noRegionCode': 'Mã vùng không được để trống',
        'msg.toast.noZone': 'Vui lòng chọn múi giờ',
        'msg.toast.noDateTime': 'Vui lòng chọn ngày giờ',
        'msg.toast.email': 'Vui lòng nhập số điện thoại  chính xác của bạn',
        'msg.toast.tel': 'Vui lòng nhập sô điện thoại  chính xác',
        'msg.toast.regionCode': 'Vui lòng chọn mã vùng',
        'msg.toast.num': 'Vui lòng nhập số chính xác ',
        'msg.toast.annex': 'Vui lòng tải lên tệp đính kèm',
        'msg.toast.char': 'Vui lòng nhập các ký tự chính xác',
        'msg.list.none': 'Chưa có dữ liệu',
        'msg.form.choose': 'Vui lòng chọn',
        'msg.form.chooseZone': 'Chọn múi giờ',
        'msg.form.chooseTime': 'Chọn thời gian',
        'msg.form.chooseDate': 'Chọn ngày',
        'msg.form.sure': 'Xác định',
        'msg.form.search': 'Tìm kiếm',
        'msg.form.uploadError': 'Sai định dạng',
        'msg.form.uploadXss':
            'Tải lên không thành công, nội dung tệp chứa tập lệnh bất hợp pháp',
        'msg.update.time': 'cập nhật trên',
        'msg.replace.images': 'hình ảnh',

        MSG016: 'giải quyết',
        MSG017: 'chưa được giải quyết',
        MSG019: 'nộp',
        MSG072: 'Nhãn đánh giá không được để trống! ',
        MSG073: 'Ngôn ngữ đánh giá không được để trống! ',
        MSG074: 'Nhãn:',
        MSG075: 'Nó đã được giải quyết chưa:',
        MSG076: 'Vui lòng chọn xem sự cố đã được giải quyết chưa',
        MSG015: 'Phiếu này có giải quyết được vấn đề của bạn không?',

        'file.size.limit': 'Kích thước tệp không được vượt quá 50MB',
        'detail.file.limit': 'Tối đa là 15, kích thước không vượt quá 50M',
        'form.question.des.tip': 'Vui lòng nhập mô tả vấn đề',
        'form.title.tip': 'Vui lòng nhập tiêu đề ',
        'form.class.tip': 'Vui lòng nhập phân loại vấn đề ',
        'upload.file': 'Vui lòng tải lên tệp đính kèm',
        'file.count.limit': 'Bạn chỉ có thể tải lên tối đa 15 tệp đính kèm',
        'select.search.placeholder': 'Tìm từ khóa',
        'msg.form.sizeError1': 'Vui lòng tải lên các tệp đính kèm nhỏ hơn 5M',
        'msg.form.sizeError2': 'Vui lòng tải lên các tệp đính kèm nhỏ hơn 50M',
        'msg.form.submit': 'Đang nập ',
        'msg.form.upload': 'Đang tải lên',
        'msg.email.tip1': 'Không tìm thấy lời dặn dò  của bạn',
        'msg.email.tip2':
            'Nếu bạn đã để lại tin nhắn trước đó, bạn có thể kiểm tra nó bằng cách xác minh email',
        'msg.email.tip3': 'Bắt đầu xác minh email',
        'msg.email.noData': 'Không có dữ liệu trong tài khoản hiện tại',
        'email.verify.tip':
            'Nhập địa chỉ email được sử dụng khi để lại tin nhắn',
        'email.input.placeholder': 'Vui lòng nhập địa chỉ email',
        'email.submit': 'Gửi email',
        'email.rules.error': 'Vui lòng nhập số điện thoại  chính xác của bạn',
        'email.code.tip':
            'Email đã được gửi, vui lòng nhập mã xác minh bạn nhận được',
        'email.code.placeholder': 'Vui lòng nhập mã xác nhận',
        'email.code.submit': 'Xem ngay bây giờ',
        'email.notFind.customer': 'Thông tin khách hàng không tìm thấy',
        'email.code.wrong': 'Mã xác minh sai, vui lòng nhập lại',
        'email.code.expired':
            'Mã xác minh đã hết hạn, vui lòng xác minh lại email',
        'email.code': 'Mã xác nhận',
        'email.send.frequently':
            'Thao tác này quá thường xuyên, vui lòng thử lại sau',
        'comment.fail.400133': 'Vé này đã được xếp hạng',
        'not.get.user.info': 'Không thể lấy thông tin của bạn',
        'user.verify.tip':
            'Bạn cần xác minh để xem nội dung danh sách tin nhắn',
        'verify.type.email': 'Xác minh hộp thư',
        'verify.text': 'Kiểm tra',
        'cancel.text': 'Hủy bỏ',
        'get.verify.code': 'Nhận CAPTCHA',
        'reGet.verify.code': 'Nhận lại ',
        'verify.by.email.tip':
            'Mã xác minh sẽ được gửi qua đường bưu điện đến tài khoản hộp thư bạn đã nhập',
        'verify.type.phone': 'Xác minh SMS',
        'phone.placeholder': 'Vui lòng nhập số điện thoại',
        'verify.by.phone.tip':
            'CAPTCHA sẽ được gửi qua SMS đến số điện thoại bạn đã nhập',
        'phone.error': 'Vui lòng nhập đúng số điện thoại',
        'phone.errorCode400150': 'CAPTCHA được gửi thường xuyên',
        'phone.errorCode400233': 'Mẫu SMS không thể để trống',
        'phone.errorCode400234': 'Số dư SMS Marketing không đủ',
        'phone.errorCode400235': 'Thông báo số dư SMS không đủ',
        'phone.errorCode400247': 'Lỗi cấu hình SMS trình cắm lệnh sản xuất',
        'phone.errorCode4400248': 'Lỗi lấy mẫu SMS',
        'phone.errorCode400249':
            'Số điện thoại không phải là số điện thoại của người dùng hiện tại',
        'phone.errorCode400250': 'Captcha đã hết hạn, vui lòng lấy lại',
        'msg.you.reply': 'Đã trả lời bạn',
        'msg.no.reply':'không trả lời',
    },
    LOCALE_REQUEST: {
        400016: 'Việc lấy thông tin lệnh sản xuất đã hết hạn, vui lòng làm mới!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'xóa bỏ',
                cancel: 'Hủy bỏ',
                confirm: 'Chắc chắn',
                inert: 'chèn',
                width: 'chiều rộng',
                height: 'cao'
            },
            controls: {
                clear: 'nội dung rõ ràng',
                undo: 'thu hồi',
                redo: 'làm lại',
                fontSize: 'cỡ chữ',
                lineHeight: 'chiều cao giữa các dòng',
                letterSpacing: 'khoảng cách từ',
                textIndent: 'thụt lề đoạn văn',
                increaseIndent: 'tăng thụt đầu dòng',
                decreaseIndent: 'giảm thụt đầu dòng',
                border: 'khung',
                color: 'màu sắc',
                textColor: 'văn bản màu',
                backgroundColor: 'màu nền',
                tempColors: 'màu tạm thời',
                bold: 'in đậm',
                italic: 'chữ in nghiêng',
                underline: 'gạch dưới',
                strikeThrough: 'gạch ngang',
                fontFamily: 'nét chữ',
                textAlign: 'căn chỉnh văn bản',
                alignLeft: 'bên trái',
                alignCenter: 'ở Trung tâm',
                alignRight: 'Phải',
                alignJustify: 'cả hai đầu',
                floatLeft: 'nổi trái',
                floatRight: 'trôi sang phải',
                superScript: 'chỉ số trên',
                subScript: 'chỉ số dưới',
                removeStyles: 'phong cách rõ ràng',
                headings: 'tiêu đề',
                header: 'tiêu đề',
                normal: 'thông thường',
                orderedList: 'danh sách được yêu cầu',
                unorderedList: 'danh sách không có thứ tự',
                blockQuote: 'trích dẫn',
                code: 'mật mã',
                link: 'liên kết',
                unlink: 'liên kết rõ ràng',
                hr: 'đường chân trời',
                media: 'phương tiện truyền thông',
                mediaLibirary: 'Thư viện phương tiện',
                emoji: 'biểu hiện nhỏ',
                fullscreen: 'toàn màn hình',
                exitFullscreen: 'Thoát toàn màn hình'
            },
            linkEditor: {
                textInputPlaceHolder: 'nhập văn bản liên kết',
                linkInputPlaceHolder: 'Nhập địa chỉ liên kết',
                inputWithEnterPlaceHolder:
                    'Nhập địa chỉ liên kết và nhấn Enter',
                openInNewWindow: 'mở trong cửa sổ mới',
                removeLink: 'xóa liên kết'
            },
            audioPlayer: {
                title: 'chơi tập tin âm thanh'
            },
            videoPlayer: {
                title: 'phát tập tin video',
                embedTitle: 'phương tiện nhúng'
            },
            media: {
                image: 'hình ảnh',
                video: 'băng hình',
                audio: 'âm thanh',
                embed: 'phương tiện nhúng'
            }
        },
        finder: {
            remove: 'xóa bỏ',
            cancel: 'Hủy bỏ',
            confirm: 'xác nhận',
            insert: 'chèn mục đã chọn',
            width: 'chiều rộng',
            height: 'cao',
            image: 'hình ảnh',
            video: 'băng hình',
            audio: 'âm thanh',
            embed: 'phương tiện nhúng',
            caption: 'Thư viện phương tiện',
            dragTip: 'Nhấp hoặc kéo tệp vào đây',
            dropTip: 'Phát hành để tải lên',
            selectAll: 'chọn tất cả',
            deselect: 'hủy lựa chọn',
            removeSelected: 'xóa mục đã chọn',
            externalInputPlaceHolder: 'Tên tài nguyên|Địa chỉ tài nguyên',
            externalInputTip: `Sử dụng "|" để phân tách tên tài nguyên và địa chỉ tài nguyên`,
            addLocalFile: 'Thêm tài nguyên địa phương',
            addExternalSource: 'Thêm tài nguyên web',
            unnamedItem: 'dự án không có tiêu đề',
            confirmInsert: 'Chèn mục đã chọn'
        }
    }
}
